import React, {useContext, useEffect} from 'react';
import {Route, useHistory} from 'react-router-dom';
import AuthContext from "../../contexts/auth/AuthContext";
import routes from "../../routing/routes";
import HistoryContext from "../../contexts/history/HistoryContext";
import ForbiddenApp from "../../apps/forbidden/ForbiddenApp";


export default function ProtectedRoute({component: Component, path, ...rest}) {

    const history = useHistory();

    const historyContext = useContext(HistoryContext);

    const {user, canAccess} = useContext(AuthContext);

    const getRedirectUrl = () => {
        switch (path) {
            case routes.checkout.path:
                return routes.register.getUrl();
            default:
                return routes.login.getUrl();
        }
    };

    useEffect(() => {
        if (user !== null) {
            historyContext.setLoginReferer(null);
            return;
        }

        historyContext.setLoginReferer(history.location);
        history.push(getRedirectUrl());
    }, [user]);

    const render = (props) => {
        if (user === null) {
            return null;
        }

        if (!canAccess(path)) {
            return <ForbiddenApp/>;
        }

        return <Component {...props}/>;
    };

    return <Route {...rest} path={path} render={render}/>;
}
